import React from "react";

const Credit = () => {
  return (
    <div>
      <div className="py-[3px]">
        <div className="rounded-t-[20px] w-full bg-rose-500 text-primary-content">
          <div className="card-body py-2 items-center text-center">
            <img className="w-[30px]" src="/culogo.png" alt="" />

            <h2 className="card-title text-white">Credits</h2>
          </div>
        </div>
      </div>

      <div className="card-body py-2 ">
        <h1 className="text-xl text-center">Team : BlueSpace Tech</h1>

        <p>
          Information : All information about Chittagong University in this app
          colleted from Chittagong University official website , recent verified
          news articles. Image And Icons colleted Chittagong University official
          website ( https://cu.ac.bd/ ) and google.
        </p>

        <p>For App UI we use Daisyui </p>

        <p className="text-center">App Version : 1.0.0</p>
      </div>
    </div>
  );
};

export default Credit;
